import {useEffect} from 'react';

export default function useCallbackCaller<T, U>(callback: ((value: T) => U) | undefined, value: T) {
  useEffect(() => {
    if (callback) {
      callback(value);
    }
  }, [value, callback]);
}
